// Company facts and public website copy.

export const COMPANY = {
  legalName: '360 Digital Gurus LLC',

  /** Operating footprint */
  locationOperating: 'Global',

  /** Primary market focus */
  locationFocus: 'UAE',

  /** Public contact reach */
  locationContact: 'Global delivery',

  /** Company profile slide 1 */
  deckSubtitle: 'Empowering Businesses Globally',

  /** Public positioning */
  taglineSecondary: 'Empowering Business Transformation',
  taglineSupporting: 'A global digital partner for ERP, automation, and growth.',

  brandIntro:
    'We build practical digital systems for teams that need clearer operations, stronger customer journeys, and accountable execution from the first decision to daily use.',

  mission:
    'We help leadership teams turn fragmented work into clear ownership, reliable tools, and measurable adoption across operations, finance, brand, and growth.',
  joinCta: 'Our role is to make digital transformation usable for the people who run the business every day.',
  welcomeClosing: 'Transformation begins with practical execution.',

  /** Public odoo positioning - no tier label (Ready/Gold/Silver) on site */
  odooPartnerLabel: 'odoo Partner',

  /** Site build credit */
  poweredBy: {
    label: '360 Digital Gurus',
    url: 'https://360digitalgurus.com/',
  },

  approachLead:
    'Our delivery approach combines discovery, clean implementation, training, and ongoing improvement so every engagement moves from plan to usable outcome.',
  approachClosing:
    'Durable systems, clear ownership, and practical support keep your team moving after launch.',

  brandAbout:
    '360 Digital Gurus is a delivery partner for growing businesses that need technology decisions translated into daily operating clarity.',

  pillars: [
    {
      t: 'Collaborative Partnership',
      d: 'We work closely with your team so goals, priorities, and implementation decisions stay aligned.',
      c: '#38AECC',
    },
    {
      t: 'Client-Centric Focus',
      d: 'We shape each solution around your workflows, constraints, and growth plans.',
      c: '#0047AB',
    },
    {
      t: 'Continuous Improvement',
      d: 'We refine processes, reporting, and automations as your business evolves.',
      c: '#714B67',
    },
    {
      t: 'Innovative Solutions',
      d: 'We use modern platforms and AI carefully, where they create real operational value.',
      c: '#E42613',
    },
    {
      t: 'Quality and Excellence',
      d: 'We build with disciplined delivery, clear documentation, and support your team can rely on.',
      c: '#1D1D1B',
    },
  ],
};

export function getAboutIntro() {
  return `${COMPANY.legalName} helps growing teams turn digital ambition into systems, campaigns, automations, and reporting they can actually run.`;
}

export function getAboutMission() {
  return `${COMPANY.mission} ${COMPANY.joinCta}`;
}

export function getHeroLead() {
  return 'odoo ERP, automation, AI, and digital delivery for growing teams.';
}

export function getHeroHighlights() {
  return [
    'odoo ERP implementation, migration, training, and support',
    'Digital execution that supports the operational rollout',
    'One accountable delivery team from strategy to go-live',
  ];
}

export function getHeroLeadMobile() {
  return 'odoo ERP, automation, AI, and digital delivery for growing teams.';
}

export function getAboutIntroMobile() {
  return `${COMPANY.odooPartnerLabel} for teams that need practical systems and clearer execution.`;
}

export function getFooterBlurbMobile() {
  return `${COMPANY.odooPartnerLabel}. Digital systems, automation, and global delivery.`;
}

export function getOdooPartnerLeadMobile() {
  return `${COMPANY.odooPartnerLabel} for ERP implementation and business automation.`;
}

export function getFooterBlurb() {
  return `${COMPANY.brandAbout} ${COMPANY.odooPartnerLabel}.`;
}
